// src/api/contactpersonbalance/contactPersonBalanceApi.js
import axiosClient from '../axiosClient';

export const contactPersonBalanceApi = {
  getBalances: async (page = 0, size = 20, search = '') => {
    try {
      const params = new URLSearchParams({
        page: page.toString(),
        size: size.toString(),
      });

      if (search && search.trim() !== '') {
        params.append('search', search.trim());
      }

      const data = await axiosClient.get(`/contact-person-balance?${params.toString()}`);
      
      console.log('📦 Contact Person Balance API data:', data);
      
      return data;
    } catch (error) {
      console.error('Error fetching contact person balances:', error);
      throw error;
    }
  },

  exportBalances: async (search = '') => {
    try {
      const params = new URLSearchParams();
      
      if (search && search.trim() !== '') {
        params.append('search', search.trim());
      }

      const data = await axiosClient.get(`/contact-person-balance/export?${params.toString()}`);
      return data;
    } catch (error) {
      console.error('Error exporting contact person balances:', error);
      throw error;
    }
  }
};